import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const RoleDropdown = ({
    value,
    onChange,
    roleList,
    isLoading,
    placeholder,
    className = "w-full",
    disabled = false
}) => {
    const { th } = useLanguage();

    const roleOptions = roleList?.map(role => ({
        label: role.name, 
        value: role.id   
    })) || [];

    const selectedTemplate = (option, props) => {
        if (option) {
            return option.label;
        }
        return props.placeholder;
    };

    const itemTemplate = (option) => {
        return (
            <div className="flex align-items-center p-2">
                <span>{option.label}</span>
            </div>
        );
    };

    const dropdownProps = {
        value: value,
        options: roleOptions,
        onChange: (e) => onChange(e.value),
        placeholder: placeholder || th('systemAdministrator.rolePlaceholder'),
        className: className,
        disabled: disabled || isLoading,
        filter: true,
        filterBy: "label",
        showClear: true,
        emptyMessage: th('systemAdministrator.roleEmptyMessage'),
        emptyFilterMessage: th('systemAdministrator.roleEmptyFilterMessage'),
        itemTemplate: itemTemplate,

        valueTemplate: selectedTemplate,

        optionLabel: "label",
        optionValue: "value",
        panelClassName: "role-dropdown-panel",
        filterPlaceholder: th('systemAdministrator.roleSearchPlaceholder'),
        appendTo: "self"
    };

    if (isLoading) {
        return (
            <div className="p-dropdown p-component p-disabled w-full">
                <span className="p-dropdown-label p-inputtext">
                    <i className="pi pi-spinner pi-spin mr-2"></i>
                    {th('common.loading')}
                </span>
            </div>
        );
    }

    return <Dropdown {...dropdownProps} />;
};

export default RoleDropdown;